import script from "./ChildJaw.vue?vue&type=script&setup=true&lang=js"
export * from "./ChildJaw.vue?vue&type=script&setup=true&lang=js"

import "./ChildJaw.vue?vue&type=style&index=0&id=0e45402f&scoped=true&lang=css"

import exportComponent from "/var/www/dental/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e45402f"]])

export default __exports__